import PropTypes from 'prop-types';
import React from 'react';
import ReactPlayer from 'react-player';

import RichTextConverter from '../Common/RichText/RichTextConverter';
import HeadingCtas from '../Generic/HeadingCtas';
import PageSection from '../PageSections/PageSection';
import * as styles from './VideoBkgHero.module.scss';

const VideoBkgHero = ({ fields }) => {
  return (
    <PageSection noPad fullBleed data-analytics-section={'video-background-hero'}>
      <div className={styles.headerSection}>
        <div className={styles.playerWrapper} data-analytics-component={'header-video'}>
          <ReactPlayer className={styles.reactPlayer} url={fields.videoUrl} playing muted loop />
        </div>
        <div
          className={styles.headingContentWrapper}
          data-analytics-component={'header-copy'}
          data-analytics-id={fields.heading}
        >
          <div className={styles.headingContent}>
            <h1 className={styles.heading}>{fields.heading}</h1>
            <RichTextConverter copy={fields.lede} />
            {fields.ctas && <HeadingCtas bkColor={'pink'} ctas={fields.ctas} />}
          </div>
        </div>
      </div>
    </PageSection>
  );
};

VideoBkgHero.propTypes = {
  fields: PropTypes.object,
};

export default VideoBkgHero;
